import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import ColorPalette from "../ColorPalette";

const RemiseEditor = ({ remise, onClose }) => {
  const [discountValue, setDiscountValue] = useState(remise ? remise.value : "2,00");
  const [discountType, setDiscountType] = useState(remise ? remise.type : "€"); // '€' or '%'

  const [currentColor, setCurrentColor] = useState(remise.color || "bg-green-500"); // Default color
  const [showPalette, setShowPalette] = useState(false); // Palette visibility
    const [categoryImage, setCategoryImage] = useState(null);

  const colors = [
    "bg-green-500",
    "bg-blue-500",
    "bg-red-500",
    "bg-yellow-500",
    "bg-purple-500",
    "bg-pink-500",
    "bg-gray-500",
    "bg-orange-500",
    "bg-indigo-500",
  ];

  // Handle color selection
  const handleColorChange = (color) => {
    setCurrentColor(color);
    setShowPalette(false);
  };

  // Gère la sélection de l'image
  const handleImageChange = (image) => {
    setCategoryImage(image); // Met à jour l'image de la catégorie
  };

  // Affiche ou cache la palette
  const togglePalette = () => {
    setShowPalette((prev) => !prev);
  };

  if (!remise) return null; // If no remise data is passed, return nothing

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header className="flex items-center justify-between p-4 border-b">
        <div className="flex items-center">
          <button onClick={onClose} className="flex items-center text-gray-600 hover:text-gray-900">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour
          </button>
        </div>
        <h1 className="text-lg font-medium">Edition remise</h1>
        <button className="text-emerald-500 font-medium">Enregistrer</button>
      </header>

      {/* Main Content */}
      <div className="flex flex-col items-center p-6 space-y-4">
        {/* Discount Icon */}
        {/* <div className="mb-2 relative"> */}
        <div>
        {categoryImage ? (
              <img
                src={categoryImage}
                alt="Category"
                className="w-20 h-20 object-cover rounded-lg"
                onClick={() => setShowPalette(!showPalette)}
              />
            ) : (
    <div
      className={`w-20 h-20 sm:w-24 sm:h-24 ${currentColor} rounded-lg flex items-center justify-center text-white cursor-pointer`}
      onClick={() => setShowPalette(!showPalette)}
    >
      Éditer
    </div>
            )}

    {/* Palette de couleurs */}
    {showPalette && (
        <div className="fixed inset-0 z-50 flex md:items-start bg-opacity-50">
          <div className="w-full bg-white min-h-screen md:min-h-0 md:ml-[250px] md:h-auto transition-transform duration-300 ease-out">
            <ColorPalette
              initialColor={currentColor}
              onClose={togglePalette}
              onColorChange={handleColorChange}
              onImageChange={handleImageChange} // Passer la fonction pour gérer l'image
            />
          </div>
        </div>
      )}
        </div>

        {/* Discount Name */}
       {/* Name of the remise */}
<div className="w-full max-w-md mt-6 flex items-center justify-between">
  <label htmlFor="remise-name" className="text-sm font-medium text-gray-700">Nom</label>
  <input
    id="remise-name"
    type="text"
    value={remise.name}
    className="w-full p-2 border-b text-left focus:outline-none focus:border-emerald-500"
  />
</div>

{/* Discount Value Input */}
<div className="w-full max-w-md mt-6 flex items-center justify-between">
  <label htmlFor="discount-value" className="text-sm font-medium text-gray-700">Valeur de la remise</label>
  <div className="flex items-center gap-2">
    <input
      id="discount-value"
      type="text"
      value={discountValue}
      onChange={(e) => setDiscountValue(e.target.value)}
      className="w-32 p-2 border-b text-right focus:outline-none focus:border-emerald-500"
    />
    <div className="flex border rounded-lg overflow-hidden">
      <button
        type="button"
        className={`px-4 py-2 ${discountType === "€" ? "bg-emerald-500 text-white" : "text-gray-600"}`}
        onClick={() => setDiscountType("€")}
      >
        €
      </button>
      <button
        type="button"
        className={`px-4 py-2 ${discountType === "%" ? "bg-emerald-500 text-white" : "text-gray-600"}`}
        onClick={() => setDiscountType("%")}
      >
        %
      </button>
    </div>
  </div>
</div>


        {/* Delete Button */}
        <div className="w-full max-w-md mt-8">
          <button className="w-full py-3 text-red-500 border border-red-500 rounded-lg hover:bg-red-50">
            Supprimer la remise
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemiseEditor;
